import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { MdAutorenew } from 'react-icons/md';
import { Button } from '@/components/Button';
import compact from '@/utils/compact';
import { activeSyncRequestAtom } from '../atoms/syncRequestAtom';
import type { SyncRequestSearchConditions } from '../lib/pickSyncRequestSearchConditions';
import SyncRequestDialog from './SyncRequestDialog';

interface Props {
  searchConditions: SyncRequestSearchConditions;
}

export default function SyncRequestButton({ searchConditions }: Props) {
  const [open, setOpen] = useState(false);
  const activeSyncRequest = useAtomValue(activeSyncRequestAtom);
  const isSyncing = !!activeSyncRequest;

  const hasConditions = Object.keys(compact(searchConditions)).length > 0;
  if (!hasConditions && !isSyncing) return null;

  return (
    <>
      <div className="fixed right-6 bottom-6 z-40">
        <Button
          color="secondary"
          size="md"
          type="button"
          className="shadow-layer2"
          disabled={isSyncing}
          onClick={() => setOpen(true)}
        >
          <MdAutorenew className={`size-5 ${isSyncing ? 'animate-spin' : ''}`} />
          {isSyncing ? '検索条件で同期中' : 'この条件で同期し直す'}
        </Button>
      </div>
      <SyncRequestDialog open={open} onOpenChange={setOpen} searchConditions={searchConditions} />
    </>
  );
}
